export default __webpack_public_path__ + "static/media/selecting_member.55d564af.png";